<template>
  <ul class="nav nav-pills ml-auto mt-2 mt-lg-0" style="margin-right: 15px;">
    <li class="nav-item">
      <router-link
        :class="$route.path === '/admin' || $route.path === '/admin/' || $route.path.includes('/admin/signature') ? 'nav-link active' : 'nav-link'"
        :to="{name: 'admin_signatures'}"
      >Andamento</router-link>
      <!-- <a class="nav-link" href="#" @click="redirectURL({name: 'admin_signatures'})">Andamento</a> -->
    </li>
    <!-- <li class="list-inline-item dot">|</li> -->
    <li class="nav-item">
      <router-link
        :class="$route.path.includes('/admin/publication') ? 'nav-link active' : 'nav-link'"
        :to="{name: 'admin_publications'}"
      >Publicações</router-link>
      <!-- <a class="nav-link" href="#" @click="redirectURL({name: 'admin_publications'})">Publicações</a> -->
    </li>
    <!-- <li class="list-inline-item dot">|</li> -->
    <li class="nav-item">
      <router-link
        :class="$route.path.includes('/admin/user') ? 'nav-link active' : 'nav-link'"
        :to="{name: 'admin_users'}"
      >Usuários</router-link>
      <!-- <a class="nav-link" href="#" @click="redirectURL({name: 'admin_users'})">Usuários</a> -->
    </li>
    <!-- <li class="list-inline-item dot">|</li> -->
    <li class="nav-item">
      <router-link
        :class="$route.path.includes('/admin/order') ? 'nav-link active' : 'nav-link'"
        :to="{name: 'admin_orders'}"
      >Pedidos</router-link>
      <!-- <a class="nav-link" href="#" @click="redirectURL({name: 'admin_orders'})">Pedidos</a> -->
    </li>
    <!-- <li class="list-inline-item dot">|</li> -->
    <li class="nav-item">
      <router-link
        :class="$route.path.includes('/admin/expedition') ? 'nav-link active' : 'nav-link'"
        :to="{name: 'admin_expeditions'}"
      >Expedições</router-link>
      <!-- <a class="nav-link" href="#" @click="redirectURL({name: 'admin_expeditions'})">Expedições</a> -->
    </li>
    <!-- <li class="list-inline-item dot">|</li> -->
    <li class="nav-item dropdown">
      <router-link
        class="nav-link dropdown-toggle"
        id="dropdownMenuButton"
        :class="$route.path.includes('/admin/report') ? 'nav-link active' : 'nav-link'"
        data-toggle="dropdown"
        aria-haspopup="true"
        aria-expanded="false"
        to="#"
      >Relatórios</router-link>
      <div class="dropdown-menu" aria-labelledby="dropdownMenuButton">
        <router-link
          :class="$route.path.includes('/admin/report/order_prefix') ? 'dropdown-item active' : 'dropdown-item'"
          :to="{name: 'order_prefix', params: { prefix:'null' }}"
        >Pedidos por prefixo</router-link>
        <router-link
          :class="$route.path.includes('/admin/report/paid_orders') ? 'dropdown-item active' : 'dropdown-item'"
          :to="{name: 'paid_orders'}"
        >Pedidos concluídos</router-link>
        <router-link
          :class="$route.path.includes('/admin/report/publication_price') ? 'dropdown-item active' : 'dropdown-item'"
          :to="{name: 'publication_price'}"
        >Lista de preços</router-link>
        <router-link
          :class="$route.path.includes('/admin/report/expedition_list') ? 'dropdown-item active' : 'dropdown-item'"
          :to="{name: 'expedition_list'}"
        >Expedição</router-link>
        <router-link
          :class="$route.path.includes('/admin/report/expired_signatures') ? 'dropdown-item active' : 'dropdown-item'"
          :to="{name: 'expired_signatures'}"
        >Assinaturas vencidas</router-link>
      </div>
    </li>
    <!-- <li class="list-inline-item dot">|</li> -->
  </ul>
</template>

<script>
import mixins from "../../../helpers/mixins";
export default {
  name: "linksMenuAdmin",
  mixins: [mixins],
};
</script>

<style scoped>
</style>
